import { forwardRef } from 'react';
import { Form } from 'react-bootstrap';
import DatePicker from 'react-datepicker';

const parseDateValue = (value) => {
	if (!value) return null;
	const parsed = new Date(`${value}T00:00:00`);
	return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const formatDateValue = (date) => {
	if (!date) return '';
	const y = date.getFullYear();
	const m = String(date.getMonth() + 1).padStart(2, '0');
	const d = String(date.getDate()).padStart(2, '0');
	return `${y}-${m}-${d}`;
};

const DatePickerInput = forwardRef(({ id, name, value, onClick, onChange, placeholder, disabled, ariaLabel, controlSize = 'sm' }, ref) => (
	<Form.Control
		ref={ref}
		id={id}
		name={name}
		{...(controlSize ? { size: controlSize } : {})}
		value={value ?? ''}
		onClick={onClick}
		onChange={onChange}
		readOnly
		disabled={disabled}
		aria-label={ariaLabel}
		placeholder={placeholder}
		className='order-list-date-input'
	/>
));

DatePickerInput.displayName = 'DatePickerInput';

const currentYear = new Date().getFullYear();
const ORDER_DATE_PICKER_MIN_DATE = new Date(2024, 0, 1);
const ORDER_DATE_PICKER_MAX_DATE = new Date(currentYear + 1, 11, 31);
export const ORDER_DATE_PICKER_FUTURE_MAX_DATE = new Date(currentYear + 5, 11, 31);
/** 产品批次效期：可录近过去、可点到较远未来 */
export const PRODUCT_BATCH_EXPIRY_MIN_DATE = new Date(currentYear - 5, 0, 1);
export const PRODUCT_BATCH_EXPIRY_MAX_DATE = new Date(currentYear + 10, 11, 31);
const ORDER_DATE_PICKER_PORTAL_ID = 'react-datepicker-portal';

/** 中文日期选择器；onChange 仍输出 YYYY-MM-DD 字符串以兼容筛选逻辑 */
const OrderListDateInput = ({
	id,
	name,
	value,
	onChange,
	placeholder,
	ariaLabel,
	disabled = false,
	minDate,
	maxDate,
	fullWidth = false,
	controlSize = 'sm',
	dateFormat = 'yyyy/MM/dd',
}) => {
	const resolvedMinDate = minDate ?? ORDER_DATE_PICKER_MIN_DATE;
	const resolvedMaxDate = maxDate ?? ORDER_DATE_PICKER_MAX_DATE;
	const yearSpan = Math.max(1, resolvedMaxDate.getFullYear() - resolvedMinDate.getFullYear() + 1);
	return (
	<div className='order-list-date-input-wrap' style={fullWidth ? { maxWidth: 'none', width: '100%', flex: '1 1 auto' } : undefined}>
		<DatePicker
			selected={parseDateValue(value)}
			onChange={(date) => {
				onChange?.({ target: { value: formatDateValue(date), name } });
			}}
			locale='zh-CN'
			dateFormat={dateFormat}
			placeholderText={placeholder}
			disabled={disabled}
			minDate={resolvedMinDate}
			maxDate={resolvedMaxDate}
			showMonthDropdown
			showYearDropdown
			dropdownMode='select'
			scrollableYearDropdown
			yearDropdownItemNumber={yearSpan}
			customInput={<DatePickerInput id={id} name={name} placeholder={placeholder} ariaLabel={ariaLabel} controlSize={controlSize} />}
			popperPlacement='bottom-start'
			popperProps={{ strategy: 'fixed' }}
			portalId={ORDER_DATE_PICKER_PORTAL_ID}
			showPopperArrow={false}
			calendarClassName='order-list-date-picker'
		/>
	</div>
	);
};

export default OrderListDateInput;
